import { type BaseMenuData } from "@/configs/menuDataDefinition";
import { Box, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import { theme as appTheme } from "@/types/theme";

export interface CategoryContainerProps extends BaseMenuData {
  children: React.ReactNode;
}

export const CategoryContainer: React.FC<CategoryContainerProps> = (props) => {
  return (
    <>
      <Box sx={{ mt: 0, py: 3, px: 0 }}>
        <Stack direction={"row"} gap={1} alignItems="center" p={"0 0 1rem 0"}>
          {props.icon != null
            ? React.createElement(props.icon, {
                sx: {
                  color: appTheme.palette.primary.main,
                  fontSize: "24px",
                },
              })
            : null}
          <Typography variant="h4" sx={{ fontSize: "20px", fontWeight: 500 }}>
            {props.title}
          </Typography>
        </Stack>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 2, sm: 2, md: 4 }}
          useFlexGap
          flexWrap="wrap"
        >
          {props.children}
        </Stack>
      </Box>
    </>
  );
};
